var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "portlet light" }, [
    _c(
      "div",
      { staticClass: "portlet-body" },
      [
        _c(
          "wes-message",
          _vm._b({}, "wes-message", _vm.getMessagePanel(), false)
        ),
        _vm._v(" "),
        _vm._t("filtro"),
        _vm._v(" "),
        this.showCheckBox && this.data && this.data.length > 0
          ? _c(
              "div",
              [
                _vm._v("\n            Mostrar:  \n            "),
                _vm._l(
                  this.fields.filter(function (item) {
                    return item.groupIndex >= 0 && item.groupName !== "Date"
                  }),
                  function (item, index) {
                    return _c(
                      "label",
                      { key: index, staticClass: "mt-checkbox" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.caption + "     ") +
                            "\n                "
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.visible,
                              expression: "item.visible",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(item.visible)
                              ? _vm._i(item.visible, null) > -1
                              : item.visible,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.checkClick(item)
                            },
                            change: function ($event) {
                              var $$a = item.visible,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(item, "visible", $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      item,
                                      "visible",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(item, "visible", $$c)
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span"),
                      ]
                    )
                  }
                ),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { attrs: { id: "pivotgrid" } }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }